import { createFileRoute, redirect } from '@tanstack/react-router';
import { NotFoundComponent } from '~/components/DefaultNotFound';

export const Route = createFileRoute('/packs/')({
    loaderDeps: ({ search: { list } }) => ({ list }),
    loader: async ({ parentMatchPromise }) => {
        const pack_tiers = (await parentMatchPromise).loaderData;
        const firstTierOrderedPacks = pack_tiers?.[0]?.packs?.sort((a, b) =>
            a.name.localeCompare(b.name),
        );
        const first_pack = firstTierOrderedPacks
            ? firstTierOrderedPacks[0]
            : undefined;

        if (first_pack) {
            throw redirect({
                from: '/packs/',
                to: '/packs/$packid',
                params: {
                    packid: `${first_pack.id}`,
                },
                search: (prev) => prev,
                replace: true,
            });
        }
    },
    // Rendered when loader finds no pack to redirect.
    component: () => (
        <div className="m-auto">
            <NotFoundComponent customNotFound="No packs found." />
        </div>
    ),
});
